import React from 'react';

import Joi from 'joi';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import useValidator from 'react-joi';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import { filterDateC } from 'components/DateCatalogs/filterDate';


import { getQuestions, getComponents, getGroupOptions, addOrUpdateQuestions, deleteQuestions, updateQuestionOrderList } from 'actions/Catalogs';

import { useLocation } from 'react-router-dom';
import Grid from 'components/Grid';
import InputCustom from 'components/InputCustom';
import Modal from 'components/Modal';
import { notify } from 'utils';
import Swal from 'sweetalert2';

const Question = ({ view }) => {

    const [t] = useTranslation("catalog");
    const [tg] = useTranslation("global");
    const location = useLocation();
    const dispatch = useDispatch();
    const { questionsList } = useSelector((state) => state.catalog);
    const { listQuestion } = questionsList;
    const { componentsList } = useSelector((state) => state.catalog);
    const { groupOptionList } = useSelector((state) => state.catalog);


    const [haveGroupResponse, setHaveGroupResponse] = React.useState(false);
    const [question, setQuestion] = React.useState(false);
    const [openModal, setOpenModal] = React.useState(false);
    const [showError, setShowError] = React.useState(false);
    const [id, setId] = React.useState();
    const [isLoad, setIsLoad] = React.useState(false);
    const [drag, setDrag] = React.useState(false);
    const { permissions } = view;

    const dragItem = React.useRef();
    const dragOverItem = React.useRef();

    const handleSort = () => {
        //duplicate items
        let _questionList = [...question];

        //remove and save the dragged item content
        const draggItemContent = _questionList.splice(dragItem.current, 1)[0]

        //switch tje position
        _questionList.splice(dragOverItem.current, 0, draggItemContent);

        //reset the position ref
        dragItem.current = null;
        dragOverItem.current = null;

        //update the actual array
        setQuestion(_questionList);
    }

    const { state, setData, setExplicitField, validate } = useValidator({
        initialData: {
            question: null,
            idComponent: null,
            idGroup: null,
            required: false,
            active: false
        },
        schema: Joi.object({
            question: Joi.string()
                .required()
                .messages({
                    'string.empty': t("error.empty"),
                    'string.base': t("error.type", { type: 'string' }),
                    'string.min': t("error.min"),
                    'string.max': t("error.max", { quantity: '200' }),
                    'any.required': t("error.required")
                }),
            idComponent: Joi.number().required(),
            required: Joi.boolean().required().allow(null),
            idGroup: Joi.number().allow(null)

        }),
        explicitCheck: {
            name: false,
            description: false,
            order: false,
            idComponent: false,
            required: false,
            idGroup: false
        },
        validationOptions: {
            abortEarly: true,
        },
    });

    const buttonRef = React.useRef();

    React.useEffect(() => {
        if (location.state && location?.state["idPoll"]) {
            dispatch(getQuestions(location.state["idPoll"]));
            dispatch(getComponents());
            dispatch(getGroupOptions());
        }

    }, [dispatch, location.state]);

    const handleSelect = async (e) => {
        setIsLoad(true);

        let _newQuestionList = question.map((item, index) => ({
            "id": item.id,
            "order": index + 1,

        }))
        if (buttonRef & buttonRef?.current) buttonRef.current.disabled = true;
        dispatch(updateQuestionOrderList(_newQuestionList, location.state["idPoll"]));
        if (buttonRef & buttonRef?.current) buttonRef.current.disabled = false;
        setIsLoad(false);
        setOpenModal(false);
        setDrag(false);
    }
    const handleOnSubmit = async () => {
        const { question, idComponent, idGroup, required, active } = state.$data;
        let group;
        if (state.$all_errors.length > 0 || state.$all_source_errors.length > 0) {
            setShowError(true);
            validate();
            notify("error", t("error.general_toast"), 1200);
            return;
        }

        setIsLoad(true);
        if (buttonRef & buttonRef?.current) buttonRef.current.disabled = true;

        !haveGroupResponse ? group = null : group = idGroup;

        let isSuccess = await dispatch(
            addOrUpdateQuestions({
                idPoll: location.state["idPoll"],
                question,
                idComponent,
                idGroup: group,
                required,
                active,
                id
            })
        );
        if (buttonRef & buttonRef?.current) buttonRef.current.disabled = false;
        setIsLoad(false);
        setShowError(false);
        if (isSuccess) {
            setData((old) => ({
                ...old,
                question: null,
                idComponent: null,
                idGroup: null,
                required: false
            }));
            setId(null);
            setOpenModal(false);
            setHaveGroupResponse(false);
        }
    };

    const handleDelete = async (id) => {
        Swal.fire({
            title: tg("button.title"),
            text: tg("button.text"),
            icon: "error",
            confirmButtonText: tg("button.confirm"),
            cancelButtonText: tg("button.cancel"),
            cancelButtonColor: "#000000",
            confirmButtonColor: "#FF3447",
            showCancelButton: true,
        }).then(async (result) => {
            if (result.isConfirmed && id) {
                dispatch(deleteQuestions(id, location.state["idPoll"]));
            }
        });
    };

    return (
        <>
            <Grid

                title={location.state["name_poll"] + " - " + t("questions.title")}
                columns={[
                    {
                        Header: "Id",
                        accessor: "id",
                        filter: "text",
                        width: '10%'
                    },
                    {
                        Header: t("questions.question"),
                        accessor: "questionDescription",
                        filter: "text",
                        width: '30%',
                    },
                    {
                        Header: t("questions.component"),
                        accessor: "componentName",
                        filter: "text",
                        width: '30%',
                    },
                    {
                        Header: t("questions.updated_at"),
                        accessor: "updatedAt",
                        filter: filterDateC,
                        Cell: ({ value }) => {
                            if (value) return format(parseISO(value), "dd/MM/yyyy HH:mm");
                            return value;
                        },
                        width: '20%',
                    },

                ]}
                data={
                    listQuestion || []
                }
                handleAdd={() => {
                    if (permissions.write) {
                        setOpenModal(true);
                    }
                }}
                handleEdit={(row) => {
                    const { questionDescription, idComponent, idGroup, required, id, order, componentHaveGroupResponse, active } = row;
                    setId(id);
                    setData((old) => ({
                        ...old,
                        question: questionDescription,
                        idComponent,
                        idGroup,
                        required,
                        order,
                        active
                    }));
                    if (componentHaveGroupResponse) {
                        setHaveGroupResponse(true);
                    }
                    setOpenModal(true);
                }}
                handleDelete={({ id }) => handleDelete(id)}
                write={permissions.write}
                controlersHeaderComponents={() => (
                    permissions.write ? <div className="flex flex-row items-center">
                        <button
                            className="bg-[#d3d3d3] rounded-full h-[30px] w-[30px]  hover:bg-gray-200 p-2 flex items-center justify-center"
                            onClick={() => {
                                if (true) {
                                    let question = [...listQuestion].sort((a, b) => a.order - b.order);
                                    setQuestion(question);
                                    setDrag(true);
                                    setOpenModal(true);
                                }
                            }}
                            title={t("questions.question_list")}
                        >
                            <svg width="150" height="150" viewBox="0 0 150 150" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M28.8623 7.63733C28.2101 11.4818 28.9512 15.4329 30.9524 18.7797C32.9535 22.1265 36.0834 24.6492 39.7788 25.8941C41.897 26.4585 44.08 26.7432 46.2721 26.7411C57.1886 26.7411 68.105 26.7411 79.0214 26.7411C81.4855 26.9194 83.9582 26.5444 86.2585 25.6433C88.5588 24.7422 90.6284 23.3379 92.3156 21.5334C94.0029 19.7288 95.2651 17.5696 96.0098 15.2141C96.7545 12.8585 96.9628 10.3662 96.6195 7.91965V7.54322H109.042C110.299 7.46004 111.56 7.64645 112.739 8.08996C113.919 8.53347 114.99 9.22385 115.881 10.1149C116.772 11.0059 117.462 12.077 117.906 13.2565C118.349 14.436 118.536 15.6966 118.452 16.9539C118.503 17.3602 118.503 17.7711 118.452 18.1773V140.517C118.536 142.616 117.914 144.684 116.686 146.39C115.458 148.095 113.695 149.34 111.677 149.927C110.675 150.024 109.667 150.024 108.665 149.927H16.9107C14.4148 149.927 12.0212 148.936 10.2563 147.171C8.49148 145.406 7.5 143.012 7.5 140.517V18.1773C7.5 15.6814 8.49148 13.2878 10.2563 11.5229C12.0212 9.7581 14.4148 8.76661 16.9107 8.76661H28.58L28.8623 7.63733ZM75.9159 99.1094H99.725C101.984 99.1094 103.301 98.0742 103.301 96.1921C103.301 94.31 102.078 93.1807 99.6309 93.1807H52.5773C51.8245 93.1807 50.9775 93.1807 50.507 93.1807C49.6309 93.7391 48.9169 94.518 48.4366 95.4392C48.2139 96.0022 48.2168 96.6293 48.4446 97.1902C48.6725 97.7511 49.1078 98.2025 49.66 98.4507C50.5269 98.7964 51.4565 98.9567 52.3891 98.9212L75.9159 99.1094ZM75.9159 65.325H51.0716C50.3759 65.4494 49.7462 65.8146 49.2926 66.3565C48.839 66.8984 48.5905 67.5826 48.5905 68.2893C48.5905 68.9961 48.839 69.6803 49.2926 70.2222C49.7462 70.7641 50.3759 71.1293 51.0716 71.2537H100.666C101.39 71.1833 102.061 70.8452 102.549 70.3055C103.036 69.7659 103.304 69.0636 103.301 68.3364C103.307 67.5989 103.042 66.8848 102.556 66.3298C102.07 65.7747 101.398 65.4171 100.666 65.325H75.8218H75.9159ZM75.9159 126.965H99.1604C99.7527 127.059 100.356 127.059 100.948 126.965C101.637 126.83 102.254 126.451 102.686 125.898C103.119 125.345 103.337 124.655 103.301 123.954C103.284 123.257 103.019 122.59 102.553 122.072C102.087 121.554 101.451 121.22 100.76 121.13H51.1657C50.45 121.178 49.7794 121.497 49.29 122.021C48.8006 122.545 48.5291 123.236 48.5307 123.954C48.4953 124.679 48.7234 125.393 49.1731 125.964C49.6228 126.535 50.2636 126.924 50.9775 127.059C51.5726 127.106 52.1704 127.106 52.7655 127.059L75.9159 126.965ZM75.9159 37.4693H50.8834C50.2389 37.5719 49.6475 37.8876 49.2036 38.366C48.7597 38.8443 48.489 39.4577 48.4348 40.108C48.3806 40.7584 48.546 41.4081 48.9046 41.9533C49.2632 42.4986 49.7943 42.9078 50.4129 43.1157C51.163 43.2064 51.9213 43.2064 52.6714 43.1157H99.0663C99.7529 43.2135 100.45 43.2135 101.137 43.1157C101.821 43.0003 102.433 42.6192 102.838 42.0552C103.244 41.4913 103.41 40.7902 103.301 40.1043C103.302 39.4214 103.037 38.7651 102.563 38.2735C102.089 37.782 101.443 37.4937 100.76 37.4693H75.9159ZM28.58 124.236C28.2183 123.669 27.809 123.134 27.3566 122.636C27.0913 122.308 26.7598 122.038 26.3836 121.846C26.0075 121.654 25.5951 121.543 25.1733 121.521C24.7515 121.498 24.3297 121.565 23.9354 121.716C23.541 121.867 23.1828 122.1 22.8841 122.399C22.5855 122.697 22.353 123.055 22.2017 123.45C22.0505 123.844 21.9839 124.266 22.0063 124.688C22.0288 125.11 22.1397 125.522 22.3318 125.898C22.524 126.274 22.7931 126.606 23.1218 126.871L26.3214 129.882C26.6047 130.309 26.9893 130.66 27.4408 130.902C27.8924 131.144 28.3969 131.271 28.9094 131.271C29.4219 131.271 29.9264 131.144 30.3779 130.902C30.8295 130.66 31.214 130.309 31.4973 129.882L39.0259 122.354C40.6257 120.66 40.8139 118.872 39.5905 117.554C38.3671 116.237 36.485 116.425 34.7911 117.554C33.0971 118.684 30.8386 121.977 28.58 124.236ZM28.58 68.7128C28.2468 68.0906 27.8694 67.4931 27.4507 66.9248C27.2043 66.5581 26.8803 66.2501 26.5016 66.0226C26.1229 65.7952 25.6987 65.6538 25.2593 65.6086C24.8198 65.5634 24.3758 65.6154 23.9587 65.761C23.5416 65.9066 23.1616 66.1422 22.8457 66.4511C22.5299 66.7599 22.2858 67.1345 22.1309 67.5482C21.976 67.9619 21.914 68.4047 21.9493 68.845C21.9846 69.2854 22.1164 69.7126 22.3353 70.0963C22.5542 70.4801 22.8548 70.811 23.2159 71.0655C24.157 72.1007 25.1921 73.1359 26.2273 74.0769C27.2625 75.018 29.6152 76.0532 31.5914 74.0769L38.8377 66.8307C40.6257 65.0426 40.908 63.2546 39.5905 61.9371C38.273 60.6196 36.485 60.8078 34.697 62.5018L28.58 68.7128ZM28.58 96.1921L27.1684 94.7805C26.8864 94.4754 26.5444 94.232 26.1638 94.0655C25.7832 93.899 25.3723 93.813 24.9569 93.813C24.5415 93.813 24.1305 93.899 23.7499 94.0655C23.3693 94.232 23.0273 94.4754 22.7454 94.7805C22.4378 95.0708 22.1927 95.4208 22.0252 95.8092C21.8577 96.1976 21.7713 96.6161 21.7713 97.0391C21.7713 97.462 21.8577 97.8805 22.0252 98.2689C22.1927 98.6573 22.4378 99.0073 22.7454 99.2976L25.8509 102.309C26.1398 102.698 26.5158 103.015 26.9489 103.232C27.3819 103.45 27.86 103.564 28.3447 103.564C28.8295 103.564 29.3076 103.45 29.7406 103.232C30.1737 103.015 30.5497 102.698 30.8386 102.309L38.5554 94.5923C38.9099 94.3356 39.2061 94.0069 39.4247 93.6277C39.6433 93.2486 39.7792 92.8275 39.8237 92.3921C39.8681 91.9567 39.82 91.5168 39.6825 91.1013C39.545 90.6858 39.3213 90.304 39.0259 89.981C37.6143 88.6635 35.9204 88.7576 34.2264 90.4516L28.58 96.1921ZM28.58 40.6689C28.28 40.2535 27.9326 39.8745 27.5448 39.5396C27.2622 39.2032 26.9093 38.9327 26.511 38.7471C26.1127 38.5616 25.6786 38.4654 25.2392 38.4654C24.7998 38.4654 24.3657 38.5616 23.9674 38.7471C23.5691 38.9327 23.2162 39.2032 22.9336 39.5396C22.626 39.8299 22.3809 40.18 22.2134 40.5684C22.0459 40.9567 21.9595 41.3752 21.9595 41.7982C21.9595 42.2212 22.0459 42.6397 22.2134 43.028C22.3809 43.4164 22.626 43.7665 22.9336 44.0568L25.7568 46.88C27.733 48.8562 29.1446 48.8562 31.0268 46.88C32.9089 44.9037 36.1086 41.8923 38.5554 39.3514C41.0021 36.8105 40.3434 35.8695 38.5554 34.552C38.2568 34.2417 37.8988 33.9949 37.5026 33.8263C37.1064 33.6577 36.6803 33.5708 36.2497 33.5708C35.8192 33.5708 35.3931 33.6577 34.9969 33.8263C34.6007 33.9949 34.2426 34.2417 33.9441 34.552L28.58 40.6689Z" fill="#222222" />
                                <path d="M147.532 51.6794H128.711V126.965H147.532V51.6794Z" fill="#222222" />
                                <path d="M62.834 20.7181H45.1418C42.6157 20.4825 40.2617 19.3356 38.5193 17.4915C36.7769 15.6475 35.7651 13.2323 35.6729 10.6969C35.5807 8.16155 36.4144 5.67928 38.0183 3.71354C39.6222 1.7478 41.8867 0.432962 44.389 0.014501C49.8472 0.014501 55.3054 0.014501 60.8577 0.014501H80.8084C82.8489 -0.0988851 84.8709 0.45505 86.5687 1.59258C88.2665 2.73011 89.5479 4.38941 90.2191 6.31968C91.0606 8.14481 91.3311 10.1815 90.9952 12.163C90.6594 14.1445 89.7328 15.9784 88.337 17.4243C87.2789 18.5683 85.9761 19.4587 84.5259 20.029C83.0757 20.5993 81.5154 20.8349 79.9615 20.7181H62.834Z" fill="#222222" />
                                <path d="M127.58 48.9503C127.58 44.2449 127.58 39.5396 127.58 35.0224C127.866 32.2566 129.232 29.7156 131.383 27.9529C133.533 26.1903 136.293 25.3488 139.061 25.6117C141.648 25.9113 144.036 27.15 145.77 29.0927C147.505 31.0355 148.466 33.5473 148.472 36.1517V48.9503H127.58Z" fill="#222222" />
                                <path d="M128.711 133.647H147.532C147.523 133.803 147.523 133.96 147.532 134.117C145.274 138.446 143.203 142.775 140.945 147.104C140.708 147.602 140.335 148.023 139.868 148.318C139.402 148.613 138.862 148.769 138.31 148.769C137.758 148.769 137.218 148.613 136.751 148.318C136.285 148.023 135.912 147.602 135.675 147.104C133.322 143.057 131.158 138.352 128.711 133.647Z" fill="#222222" />
                            </svg>

                        </button>
                    </div> : null
                )}
            />
            {openModal ? (
                <Modal
                    openModal={openModal}
                    closeModal={() => {
                        setData((old) => ({
                            ...old,
                            question: null,
                            order: null,
                            idComponent: null,
                            idGroup: null,
                            required: false,
                            active: false
                        }));
                        setShowError(false);
                        setOpenModal(false);
                        setId(null);
                        setDrag(false);
                        setHaveGroupResponse(false);
                    }}
                    titleModal={t("questions.title")}
                    onSubmit={!drag ? handleOnSubmit : handleSelect}
                    disableAdd={state.$invalid}
                    iconEdit={id > 0 ? true : false}
                    buttonRef={buttonRef}
                    processFetch={isLoad}
                >
                    <h4 className="font-[Gravity] font-bold tex-[18px] my-2">
                        {t("questions.info_modal")}
                    </h4>

                    {drag ?
                        <div className='w-full'>
                            <div>
                                <h5>{t("questions.instructions")}:</h5>
                                <ul>
                                    <ol>{t("questions.step1")}</ol>
                                    <ol>{t("questions.step2")}</ol>
                                </ul>

                            </div>
                            {question?.map((item, index) => (

                                <div className="flex w-full mt-3 p-2 text-gray-700 bg-gray-200 border border-gray-200 rounded-lg shadow-lg shadow-gray-500/50 cursor-move" key={index} draggable="true"
                                    onDragStart={(e) => dragItem.current = index}
                                    onDragEnter={(e) => dragOverItem.current = index}
                                    onDragEnd={handleSort}
                                    onDragOver={(e) => e.preventDefault()}
                                >
                                    <p>{item.questionDescription ? item.questionDescription : item.question}</p>
                                </div>
                            ))}
                        </div>


                        : (<div className="flex flex-wrap ">
                            <InputCustom
                                type={"text"}
                                labelText={t("questions.question")}
                                onBlur={() => setExplicitField("question", true)}
                                errorMessage={
                                    showError && state.$errors.question.length > 0 ? state.$errors.question[0].$message : null
                                }
                                onChange={(e) => {
                                    e.persist();
                                    setData((old) => ({
                                        ...old,
                                        question: e.target.value,
                                    }));
                                }}
                                value={state.$data.question ? state.$data.question : ""}
                            />
                            <InputCustom
                                type={"select"}
                                labelText={t("cedisOrigin.project")}
                                errorMessage={
                                    state.$errors.idComponent.length > 0 ? t("error.general") : null
                                }
                                onChange={(e) => {
                                    e.persist();
                                    setData((old) => ({
                                        ...old,
                                        idComponent: e.target.value,
                                    }));

                                    var filter = componentsList.filter((component, index, arra) => {

                                        if (component.id === parseInt(e.target.value)) {
                                            return component;
                                        }

                                        return null;

                                    }).map(function (item) {
                                        return item.haveGroupResponse;
                                    });

                                    setHaveGroupResponse(filter[0]);
                                }}
                                options={
                                    componentsList &&
                                    componentsList.map((item) => ({
                                        value: item.id,
                                        text: item.name,
                                    }))
                                }
                                value={state.$data.idComponent ? state.$data.idComponent : ""}
                                onBlur={() => setExplicitField("idComponent", true)}
                                key="idComponent"
                            />{haveGroupResponse ?
                                <InputCustom
                                    type={"select"}
                                    labelText={t("cedisOrigin.project")}
                                    errorMessage={
                                        state.$errors.idGroup.length > 0 ? t("error.general") : null
                                    }
                                    onChange={(e) => {
                                        e.persist();
                                        setData((old) => ({
                                            ...old,
                                            idGroup: e.target.value,
                                        }));
                                    }}
                                    options={
                                        groupOptionList &&
                                        groupOptionList.map((item) => ({
                                            value: item.id,
                                            text: item.description,
                                        }))
                                    }
                                    value={state.$data.idGroup ? state.$data.idGroup : ""}
                                    onBlur={() => setExplicitField("idGroup", true)}
                                    key="idGroup"
                                /> : null
                            }
                            <div className="flex flex-col min-w-[250px] my-[.5px] mx-1">
                                <label
                                    for="default-checkbox"
                                    className="text-black font-[Gravity] text-[14px] font-[350]"
                                >
                                    {t("questions.required")}
                                </label>
                                <input
                                    type="checkbox"
                                    onChange={(e) => {
                                        e.persist();
                                        setData((old) => ({
                                            ...old,
                                            required: e.target.checked,
                                        }));
                                    }
                                    }
                                    checked={state.$data.required}
                                    value={state.$data.required ? state.$data.required : ""}
                                    onBlur={() => setExplicitField("required", true)}
                                    key="required"
                                />

                            </div>
                            {id && <div className="flex flex-col min-w-[250px] my-[.5px] mx-1">
                                <label
                                    for="default-checkbox"
                                    class="ml-2 text-sm font-medium text-gray-900 capitalize"
                                >
                                    {t("questions.active")}
                                </label>
                                <input
                                    type="checkbox"
                                    onChange={(e) => {
                                        e.persist();
                                        setData((old) => ({
                                            ...old,
                                            active: e.target.checked,
                                        }));
                                    }
                                    }
                                    checked={state.$data.active}
                                    value={state.$data.active ? state.$data.active : ""}
                                    onBlur={() => setExplicitField("active", true)}
                                    key="active"
                                />

                            </div>}
                        </div>)}

                </Modal>
            ) : null}
        </>
    )
}

export default Question